function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Shared click away context to allow control over event propagation
 */
var ClickAwayContext = /*#__PURE__*/function () {
  function ClickAwayContext() {
    var _this = this;

    _classCallCheck(this, ClickAwayContext);

    _defineProperty(this, "_elements", []);

    _defineProperty(this, "_isPropagationStopped", false);

    _defineProperty(this, "_handleClickOutside", function (event) {
      _this._elements.forEach(function (el) {
        if (_this._isPropagationStopped) return;

        if (!el.node.contains(event.target) && typeof el.onClickAway === 'function') {
          el.onClickAway({
            stopPropagation: function stopPropagation() {
              _this._isPropagationStopped = true;
            }
          });
        }
      });

      _this._isPropagationStopped = false;
    });
  }

  _createClass(ClickAwayContext, [{
    key: "init",
    value: function init() {
      document.addEventListener('mousedown', this._handleClickOutside);
      document.addEventListener('touchstart', this._handleClickOutside);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      document.removeEventListener('mousedown', this._handleClickOutside);
      document.removeEventListener('touchstart', this._handleClickOutside);
    }
  }, {
    key: "add",
    value: function add(el) {
      var _this2 = this;

      this._elements = [el].concat(this._elements);
      return function () {
        _this2._elements = _this2._elements.filter(function (x) {
          return x !== el;
        });
      };
    }
  }]);

  return ClickAwayContext;
}();

export { ClickAwayContext as default };
var clickAwayInstance = null;
/**
 * Singleton click away context
 */

export var clickAway = function clickAway() {
  if (clickAwayInstance) return clickAwayInstance;
  clickAwayInstance = new ClickAwayContext();
  clickAwayInstance.init();
  return clickAwayInstance;
};